// extracted by mini-css-extract-plugin
export default {"container":"styles_container__gvwUb","content":"styles_content__s7pvv","img":"styles_img__9z+71","action":"styles_action__cqq9e"};